define('SuiteDynamics.HomePageHeroVideo.HeroVideo',
	[
		'SuiteDynamics.HomePageHeroVideo.HeroVideo.View'
	],
	function (
		HeroVideoView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			var layout = container.getComponent('Layout');
			if(layout) {
				layout.addChildView('Homepage.HeroVideo', function() {
					return new HeroVideoView({ container: container });
				});
			}
		}
	};
});
